import React, { useState } from 'react';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { formatCurrency, generateId } from '../utility/functions';
import Table from '../table/Table';
import useMetronome from '../utility/useMetronome';

const ExpressPassActivity = ({ ...props }) => {

    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.passActivity)
                .then(res => {
                    const data = [
                        {
                            label: 'Fleet Pass Income',
                            today: res.dailyFleetPassIncome,
                            month: res.mtdIncomeFleetPass,
                            currency: true
                        },
                        {
                            label: 'Daily Pass Income',
                            today: res.dailyDailyPassIncome,
                            month: res.mtdIncomeDailyPass,
                            currency: true
                        },
                        {
                            label: 'Fleet Pass Count',
                            today: res.dailyFleetPassCount,
                            month: res.mtdFleetPassCount,
                        },
                        {
                            label: 'Daily Pass Count',
                            today: res.dailyDailyPassCount,
                            month: res.mtdDailyPassCount,
                        },
                        {
                            label: 'Prepaid Pass Count',
                            today: res.dailyPrepaidPassCount,
                            month: res.mtdPrepaidPassCount,
                        },
                        {
                            label: 'Total Pass Count',
                            today: res.dailyTotalPassCount,
                            month: res.mtdTotalPassCount,
                        },
                        {
                            label: 'Fleet Signups',
                            today: res.dailyFleetSignups,
                            month: res.mtdFleetSignups,
                        },
                        {
                            label: 'Daily Signups',
                            today: res.dailyDailySignups,
                            month: res.mtdDailySignups,
                        },
                        {
                            label: 'Prepaid Signups',
                            today: res.dailyPrepaidSignups,
                            month: res.mtdPrepaidSignups,
                        },
                        {
                            label: 'Total Signups',
                            today: res.dailyTotalSignups,
                            month: res.mtdTotalSignups,
                        },
                        {
                            label: 'Prepaid Signup Income',
                            today: res.dailyPrepaidSignupIncome,
                            month: res.mtdPrepaidSignUpIncome,
                            currency: true
                        },
                        {
                            label: 'Recurring Billing Income',
                            today: res.dailyRecurringBillingIncome,
                            month: res.mtdRecurringBillingIncome,
                            currency: true
                        },
                        {
                            label: 'Total Income',
                            today: res.dailyTotalIncome,
                            month: res.mtdTotalIncome,
                            currency: true
                        }
                    ].filter(e => e.today > 0 || e.month > 0)

                    setData(data)
                })
                .catch(ex => console.error(ex))
        }
    }, 60000)

    return (
        <div style={{ height: '100%'}}>
            <Table
                config={{
                    disableHeaderSearch: true,
                    disableTableControls: true,
                    disableMobileView: true,
                    data: data,
                    headers: [
                        {
                            label: 'Pass Totals',
                            propKey: 'label',
                        }, {
                            label: 'Today',
                            propKey: 'today',
                        }, {
                            label: 'Month',
                            propKey: 'month',
                        }
                    ],
                    renderFormat: (e) => (
                        <tr key={generateId()}>
                            <td>{e.label}</td>
                            <td>{e.currency ? formatCurrency(e.today) : e.today}</td>
                            <td>{e.currency ? formatCurrency(e.month) : e.month}</td>
                        </tr>
                    )
                }}
            />
        </div>
    );
}

export default ExpressPassActivity;